import { Inject, Injectable } from '@angular/core';

import {
  ACCEPTED_FILE_TYPES,
  AcceptedFileTypes,
  FileTypesCategoryEnum,
} from './accepted-file-types.types';

@Injectable({ providedIn: 'root' })
export class AcceptedFileTypesService {
  public readonly byCategoryAsString: Record<FileTypesCategoryEnum, string> = <
    Record<FileTypesCategoryEnum, string>
  >Object.fromEntries(
    Object.entries(this.acceptedFileTypes).map(entry => [entry[0], entry[1].join(',')]),
  );
  constructor(@Inject(ACCEPTED_FILE_TYPES) private acceptedFileTypes: AcceptedFileTypes) {}
}
